const KEY = 'contraktor_referral_code';
const TS_KEY = 'contraktor_referral_code_ts';
const MAX_AGE_DAYS = 30;

export function setReferralCode(code) {
  const clean = code.trim().toUpperCase();
  if (!clean) return;

  localStorage.setItem(KEY, clean);
  localStorage.setItem(TS_KEY, String(Date.now()));
}

export function getReferralCode() {
  const code = localStorage.getItem(KEY);
  const ts = localStorage.getItem(TS_KEY);

  if (!code) return null;

  if (ts) {
    const age = Date.now() - Number(ts);
    const maxAge = MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
    if (age > maxAge) {
      clearReferralCode();
      return null;
    }
  }

  return code;
}

export function clearReferralCode() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(TS_KEY);
}
